import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import IframeWeb from './IframeWeb'


const Settings = () => {
    const [message, setMessage] = useState('');
    const navigate = useNavigate()

    function launchChat(){
        navigate('/chat')
    }
    return (
        // <div className='wrapper' style={{ marginTop: '6.5rem' }}>
        //     <IframeWeb height="750" source="https://trampolinehealth.circle.so/home" />
        // </div>
        <div className='wrapper' style={{ marginTop: '6.5rem', marginLeft: '1.5rem', marginRight:' 1.5rem' }}>
            <div>
                <h2 className="text-center"> Personalized Digital Wellness Support </h2>
            </div>
            <div className="container" style={{ marginTop: '2rem'}}>
                <div className="item" style={{ padding: '0' }}>
                    <h5> Application Settings </h5>
                    <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                        <button className="homeBttn" onClick={() => {navigate('/notifications')}}>Notifications</button>
                        <button className="homeBttn"  style={{ marginTop:'1rem'}} onClick={() => {navigate('/in-development')}}  >Security & Data</button>
                        <button className="homeBttn" style={{ marginTop:'1rem'}} onClick={() => {navigate('/about')}}>About</button>
                    </div>

                        {/* <div className="form-group"><label> Send a message: </label><br /> <input type="text" placeholder='question you have' value={message} onChange={event => setMessage(event.target.value)} /> <br /></div>
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div> */}
                </div>
            </div>
        </div>
)
}


export default Settings;